import React from 'react'
import { Box, Typography, Button, Stack } from '@mui/material'
import DossierModalEditButton from '../../Elements/DossierModalEditButton'

export default class BlockCardCarousel extends React.Component {
    constructor(props) {
        super(props)
        this.state = { currentIndex: 0 }
    }

    handlePrev = () => {
        this.setState((prev) => ({
            currentIndex:
                prev.currentIndex === 0
                    ? this.props.data.dossiers.length - 1
                    : prev.currentIndex - 1,
        }))
    }

    handleNext = () => {
        this.setState((prev) => ({
            currentIndex:
                prev.currentIndex === this.props.data.dossiers.length - 1
                    ? 0
                    : prev.currentIndex + 1,
        }))
    }

    getImageContent(imageField, dossierData) {
        if (!dossierData) return ''
        const baseUrl = this.props.kedo.api().getBaseUrl()
        let singleDossierData = dossierData.find(
            (data) => data.content.id === imageField.id
        )
        if (singleDossierData && singleDossierData.content) {
            singleDossierData = singleDossierData.content.content
        }

        const src =
            singleDossierData && singleDossierData.length > 0
                ? `${baseUrl}/file/${singleDossierData[0].id}/download`
                : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkqAcAAIUAgUW0RjgAAAAASUVORK5CYII='

        return (
            <Box
                component="img"
                src={src}
                alt=""
                sx={{ width: '100%', maxHeight: 400, objectFit: 'cover' }}
            />
        )
    }

    renderSlide(dossier, dossierData, pictureField, titleField, descField) {
        return (
            <Box key={dossier.id} sx={{ textAlign: 'center' }}>
                {this.getImageContent(pictureField, dossierData)}

                <Box sx={{ mt: 2 }}>
                    <Typography variant="h5">
                        <a
                            href={`/contentdossier/${dossier.id}`}
                            style={{ textDecoration: 'none', color: 'inherit' }}
                        >
                            {titleField
                                ? this.props.getValue(
                                      titleField,
                                      dossierData,
                                      dossier
                                  )
                                : dossier.summary}
                        </a>
                    </Typography>

                    {descField && (
                        <Typography variant="body1" sx={{ mt: 1 }}>
                            {this.props.getValue(
                                descField,
                                dossierData,
                                dossier
                            )}
                        </Typography>
                    )}

                    {this.props.block.settings.inline_edit && (
                        <Box sx={{ mt: 1 }}>
                            <DossierModalEditButton
                                dossierId={dossier.id}
                                kedo={this.props.kedo}
                            />
                        </Box>
                    )}
                </Box>
            </Box>
        )
    }

    render() {
        if (!this.props.block?.settings?.templateOptions) return null

        const pictureId = this.props.block.settings.templateOptions.picture
        const titleId = this.props.block.settings.templateOptions.title
        const descId = this.props.block.settings.templateOptions.description

        const pictureField = this.props.listItems.find(
            (item) => item.id === pictureId
        )
        const titleField = this.props.listItems.find(
            (item) => item.id === titleId
        )
        const descField = this.props.listItems.find(
            (item) => item.id === descId
        )

        const { currentIndex } = this.state
        const dossiers = this.props.data.dossiers || []

        if (dossiers.length === 0) return null

        const currentDossier = dossiers[currentIndex]
        const dossierData = this.props.data.contents.filter(
            (dataItem) => dataItem.id === currentDossier.id
        )

        return (
            <Box sx={{ position: 'relative' }}>
                {this.renderSlide(
                    currentDossier,
                    dossierData,
                    pictureField,
                    titleField,
                    descField
                )}

                {/* Navigation Buttons */}
                <Button
                    onClick={this.handlePrev}
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: 8,
                        transform: 'translateY(-50%)',
                    }}
                    variant="contained"
                >
                    Prev
                </Button>
                <Button
                    onClick={this.handleNext}
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        right: 8,
                        transform: 'translateY(-50%)',
                    }}
                    variant="contained"
                >
                    Next
                </Button>

                {/* Dots */}
                <Stack
                    direction="row"
                    spacing={1}
                    justifyContent="center"
                    sx={{ mt: 2 }}
                >
                    {dossiers.map((_, i) => (
                        <Box
                            key={i}
                            sx={{
                                width: 10,
                                height: 10,
                                borderRadius: '50%',
                                bgcolor:
                                    i === currentIndex
                                        ? 'primary.main'
                                        : 'grey.400',
                                cursor: 'pointer',
                            }}
                            onClick={() => this.setState({ currentIndex: i })}
                        />
                    ))}
                </Stack>
            </Box>
        )
    }
}
